// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../../stores/mobx-compat";
import moment from 'moment';

import Card from '../../../../ui/Card';
import Button from '../../../../ui/Button';
import Input from '../../../../ui/Input';
import Pill from '../../../../ui/Pill';
import { LinkIcon, ExternalLinkIcon } from '../../../../ui/icons';

const GTM_LOGO = 'https://firebasestorage.googleapis.com/v0/b/mov-configs.appspot.com/o/integrationLogos%2Fgtm_icon.svg?alt=media&token=26149fff-16ba-4622-b3c2-ec127540006c';

class TypeformCards extends Component {
  Typeform = this.props.store.integrations.Typeform;

  render() {
    const forms = this.Typeform.formData.forms || [];
    return (
      <div
        className="grid gap-4"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}
      >
        {forms.map((form) => {
          const validGtm = /^GTM-[A-Z0-9]{1,7}$/i.test(form.settings?.google_tag_manager);
          return (
            <Card key={form.id} padded style={{ borderTop: `3px solid ${form.approved ? 'var(--mov-accent)' : 'var(--mov-line-strong)'}` }}>
              <div className="flex items-center justify-between gap-2 mb-2">
                <h4 className="m-0 text-[14px] font-semibold truncate">{form.title}</h4>
                {form.approved && <Pill tone="green" dot>Linked</Pill>}
              </div>
              <a
                href={form._links?.display}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-[12px] text-mov-ink-soft hover:text-mov-ink mb-3"
              >
                {form._links?.display}
                <ExternalLinkIcon size={11} />
              </a>
              <Input
                prefix={(
                  <img src={GTM_LOGO} alt="GTM" style={{ width: 14, height: 14 }} />
                )}
                placeholder="GTM-XXXXXX"
                name={form.id}
                value={form.settings?.google_tag_manager || ''}
                onChange={this.Typeform.updateFormContainerId}
              />
              <div className="flex items-center justify-between mt-3 text-[12px] text-mov-ink-mute">
                <span className="inline-flex items-center gap-1.5">
                  <LinkIcon size={12} />
                  {form.updatedTs
                    ? `Linked ${moment(form.updatedTs).format('MM/DD/YYYY')}`
                    : 'Not linked'}
                </span>
                <Button
                  variant="primary"
                  size="sm"
                  disabled={!validGtm}
                  loading={this.Typeform.formsLoading.has(form.id)}
                  onClick={() => this.Typeform.approveForm(form.id, form.settings.google_tag_manager, form._links.display)}
                >
                  Approve
                </Button>
              </div>
            </Card>
          );
        })}
      </div>
    );
  }
}

export default inject('store')(observer(TypeformCards));
